import React, { useEffect, useState } from "react";
import styles from "./BusinessDetails.module.scss";
import {
	closeLoader,
	openLoader,
} from "../../redux/actions/loader/loaderActions";
import axios from "axios";
import { useDispatch } from "react-redux";
import { openToastAndSetContent } from "../../redux/actions/toast/toastActions";
import { useHistory, useParams } from "react-router-dom";
import { ReactComponent as PendingIcon } from "../../assets/images/alert-circle.svg";
import { ReactComponent as DangerIcon } from "../../assets/images/close-circle.svg";
import { ReactComponent as ApprovedIcon } from "../../assets/images/checkmark-circle.svg";
import Modal from "react-modal";
import { customStyles } from "../../helpers/modalStyles";
import { Box, Divider, Grid } from "@material-ui/core";
import { ReactComponent as CloseIcon } from "../../assets/images/modalclose.svg";
import EmptyStateAsset from "../../assets/images/emptystate.svg";

import {
	closeModal,
	openModalAndSetContent,
} from "../../redux/actions/modal/modalActions";
import NavBar from "../navbar/NavBar";
import ViewDocImage from "../complianceDetails/ViewDocImage";
import ViewDoc from "../complianceDetails/ViewDoc";

function Document() {
	const { id } = useParams<any>();
	const [businesses, setBusinesses] = useState<any>();
	const [docsDetails, setDocsDetails] = useState<any>();
	const history = useHistory();

	const dispatch = useDispatch();

	const [modalIsOpen, setIsOpen] = React.useState(false);
	function closeModal() {
		setIsOpen(false);
	}

	const back = "<< Back";
	const next = "Next >>";
	const imageViewerHandler = (
		idurl: string,
		idtype: string,
		status: string,
		merchantaccountidentificationid: number,
		index: number
	) => {
		setDocsDetails({
			idurl,
			idtype,
			status,
			merchantaccountidentificationid,
			index,
		});
		setIsOpen(true);
	};

	const moveHandler = (identify: string) => {
		setIsOpen(false);

		if (identify === "back") {
			const filterdata = businesses?.documents?.filter(
				(item: any, i: number) => item.id === docsDetails.id - 1
			);
			setDocsDetails(filterdata[0]);
		}

		if (identify === "next") {
			const filterdata = businesses?.documents.filter(
				(item: any) => item.id === docsDetails.id + 1
			);
			setDocsDetails(filterdata[0]);
		}

		setTimeout(() => {
			setIsOpen(true);
		}, 100);
	};

	const fetchBusinesses = async () => {
		dispatch(openLoader());
		try {
			const data: any = await axios.get(`/v1/business/${id}/documents`);
			const docs = data?.data?.documents?.map((item: any, i: number) => ({
				...item,
				id: i + 1,
			}));
			setBusinesses(docs);
			dispatch(closeLoader());
		} catch (error: any) {
			dispatch(closeLoader());
			const message = error?.response?.data?.message;
			dispatch(
				dispatch(
					openToastAndSetContent({
						toastContent: message,
						toastType: "error",
					})
				)
			);
		}
	};

	// opens verification modal
	// const handleVerify = (doc: any) => {
	//   dispatch(
	//     openModalAndSetContent({
	//       modalStyles: {
	//         padding: 0
	//       },
	//       modalContent: (
	//         <Box>
	//           <VerifyDocument doc={doc} />
	//         </Box>
	//       )
	//     })
	//   );
	// };
	// // handles document validation for intl passport
	// const handleValidateDoc = (doc: any) => {
	//   dispatch(
	//     openModalAndSetContent({
	//       modalStyles: {
	//         padding: 0
	//       },
	//       modalContent: (
	//         <Box>
	//           <ValidateDocument doc={doc} />
	//         </Box>
	//       )
	//     })
	//   );
	// };
	// handles doc validation/displays validated document
	// const handleValidateInfo = async (doc: any) => {
	//   if (doc.verifieddata !== null) {
	//     dispatch(
	//       openModalAndSetContent({
	//         modalStyles: {
	//           padding: 0
	//         },
	//         modalContent: (
	//           <Box>
	//             <ValidateInformation doc={doc} />
	//           </Box>
	//         )
	//       })
	//     );
	//   } else {
	//     youVerifyData(doc);
	//   }
	// };
	// function to validate data and display in validation modal
	// const youVerifyData = async (doc: any) => {
	//   dispatch(openLoader());
	//   let reqData = {
	//     merchantaccountid: business?.business?.merchantaccountid,
	//     docid: doc?.id
	//   };

	//   try {
	//     const { data } = await axios.post<any>(
	//       `/v1/compliance/business/docs/validate`,
	//       reqData
	//     );
	//     fetchDoc();
	//     dispatch(closeLoader());
	//     dispatch(
	//       openModalAndSetContent({
	//         modalStyles: {
	//           padding: 0
	//         },
	//         modalContent: (
	//           <Box>
	//             <ValidateInformation doc={data} />
	//           </Box>
	//         )
	//       })
	//     );
	//   } catch (error: any) {
	//     dispatch(
	//       openToastAndSetContent({
	//         toastContent: error?.response.data
	//           ? error?.response?.data?.message
	//           : error.message,toastErrorStyles
	//       })
	//     );
	//     dispatch(closeLoader());
	//     dispatch(closeModal());
	//   }
	// };

	// opens business approval modal
	// const handleApproveBusiness = (doc: any) => {
	//   dispatch(
	//     openModalAndSetContent({
	//       modalStyles: {
	//         padding: 0
	//       },
	//       modalContent: (
	//         <Box>
	//           <ApproveCompliance
	//             doc={doc}
	//             id={business?.business.merchantaccountid}
	//             type="BUSINESS"
	//             action="approve"
	//           />
	//         </Box>
	//       )
	//     })
	//   );
	// };
	// // opens doc rejection modal
	// const handleReject = (doc: any) => {
	//   dispatch(
	//     openModalAndSetContent({
	//       modalStyles: {
	//         padding: 0
	//       },
	//       modalContent: (
	//         <Box>
	//           <RejectDocument doc={doc} />
	//         </Box>
	//       )
	//     })
	//   );
	// };
	// opens modal to view a document image(if any)

	const handleViewDocImage = (docurl: string) => {
		const extension = docurl.split(".").pop();
		if (
			extension === "png" ||
			extension === "PNG" ||
			extension === "jpeg" ||
			extension === "JPEG" ||
			extension === "jpg" ||
			extension === "JPG" ||
			extension === "svg" ||
			extension === "SVG"
		) {
			dispatch(
				openModalAndSetContent({
					modalStyles: {
						padding: 0,
					},
					modalContent: (
						<Box>
							<ViewDoc docurl={docurl} />
						</Box>
					),
				})
			);
		} else {
			openToastAndSetContent({
				toastContent: "No image to view",
				toastType: "error",
			});
		}
	};

	// Define the isPdfUrl function
	const isPdfUrl = (url: string | null): boolean => {
		if (url === null) {
			return false; // Handle the case when url is null
		}

		const extension = url.split(".").pop()?.toLowerCase();
		return extension === "pdf";
	};

	useEffect(() => {
		fetchBusinesses();
	}, []);

	return (
		<>
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					width: "100%",
					background: "#EFF3F8",
					height: "100%",
					overflowY: "scroll",
				}}
			>
				<NavBar name="Documents" />
				<div className={styles.containerBusiness}>
					<Box>
						{businesses?.map((x: any) => (
							<div key={x?.id} className={styles.gridFeatures}>
								<div>
									<h5 className={styles.docName}>{x.idurl && x?.idtype}</h5>
									<div className={styles.gridFeatureBusinessFlexEnd}>
										{x.idurl && x.idurl !== null ? (
											<span style={{ display: "flex" }}>
												{isPdfUrl(x.idurl) ? (
													<a
														target="_blank"
														rel="noopener noreferrer"
														href={x.idurl}
														className={styles.gridFeatureBusinessOutlineButton}
													>
														View
													</a>
												) : (
													<button
														onClick={() => handleViewDocImage(x.idurl)}
														className={styles.gridFeatureBusinessOutlineButton}
													>
														View
													</button>
												)}

												<button
													style={{
														backgroundColor: "#FBEFC9",
														border: "1px solid #FBEFC9",
													}}
													className={styles.gridFeatureBusinessOutlineButton}
												>
													{x?.status}
												</button>
											</span>
										) : null}
										{/* {x?.idnumber !== null ? (
<button
onClick={
x?.idtype === "intpassport"
? () => handleValidateDoc(x)
: () => handleValidateInfo(x)
}
className={styles.gridFeatureBusinessOutlineButton}
>
Validate
</button>
) : null}

{x?.verifiedstatus !== "VERIFIED" && (
<>
<button
onClick={() => handleReject(x)}
className={styles.gridFeatureBusinessRedButton}
>
Reject
</button>

<button
onClick={() => handleVerify(x)}
className={styles.gridFeatureBusinessGreenButton}
>
Verify
</button>
</>
)} */}
									</div>
								</div>
								{businesses.length === 0 && (
									<>
										<div
											style={{
												textAlign: "center",
												color: "black",
												marginTop: "100px",
											}}
										>
											<img src={EmptyStateAsset} alt="" />
											<p style={{ color: "black" }}>
												No Documents Uploaded Yet
											</p>
											<p
												style={{
													color: "#9EA0B0",
													paddingTop: "20px",
													paddingBottom: "250px",
												}}
											>
												If the merchants have uploaded documents, <br /> you’d
												be able to see them here.
											</p>
										</div>
									</>
								)}
								{x.idurl && x.idurl !== null ? (
									<>
										{x?.idnumber !== null && <Divider light />}

										<Grid container spacing={2}>
											<Grid item xs={12} md={6} lg={3}>
												{x?.idnumber !== null && (
													<div className={styles.gridFeatureBusiness}>
														<h1 className={styles.gridFeatureBusinessH1}>
															Document Number
														</h1>
														<p className={styles.gridFeatureBusinessP}>
															{x?.idnumber}
														</p>
													</div>
												)}
											</Grid>
										</Grid>
									</>
								) : (
									<>
										<div
											style={{
												color: "black",
												display: "block",
											}}
										>
											{x?.idnumber !== null && (
												<div>
													<span>
														<h5 className={styles.docName}>{x?.idtype}</h5>
														<p className={styles.newP}>{x?.idnumber}</p>
													</span>
												</div>
											)}
										</div>

										{/* <Grid>
												<Grid item xs={12} md={6} lg={5}>
													{x?.idnumber !== null && (
														<div>
															<span>
																<h5 className={styles.docName}>{x?.idtype}</h5>
																<p className={styles.newP}>{x?.idnumber}</p>
															</span>
														</div>
													)}
												</Grid>
											</Grid> */}
										{/* <div
												style={{
													textAlign: "center",
													color: "black",
													marginTop: "10px",
												}}
											>
												<p style={{ color: "black" }}>No document uploaded</p>
												<p
													style={{
														color: "#9EA0B0",
														paddingTop: "20px",
														paddingBottom: "10px",
													}}
												>
													If the merchants have uploaded documents, <br /> you’d
													be able to see them here.
												</p>
											</div> */}
									</>
								)}
							</div>
						))}
					</Box>
					{/* <div className={styles.containerHeader}>
{businesses?.length > 0 ? (
businesses?.map(
(
{
idurl,
idtype,
status,
merchantaccountidentificationid
}: {
idurl: string;
idtype: string;
status: string;
merchantaccountidentificationid: number;
},
i: number
) => (
<div
key={merchantaccountidentificationid}
onClick={() =>
imageViewerHandler(
idurl,
idtype,
status,
merchantaccountidentificationid,
i
)
}
className={styles.singleDocs}
>
<p>{idtype}</p>
<div className={styles.singleDocsImage}>
<img src={idurl} alt="" />
<span>
{status === "APPROVED" ? (
<ApprovedIcon />
) : status === "PENDING" ? (
<PendingIcon />
) : (
<DangerIcon />
)}
</span>
</div>
</div>
)
)
) : (
<h1 className={styles.noDocument}>NO DOCUMENT UPLOADED YET</h1>
)}
</div> */}

					{/* <Modal
isOpen={modalIsOpen}
onRequestClose={closeModal}
contentLabel="Example Modal"
style={customStyles}
>
<div className={styles.modalBody}>
<div className={styles.modalHeader}>
<div className={styles.background}>
<div className={styles.linkDetails}>{docsDetails?.name}</div>
<CloseIcon
onClick={closeModal}
style={{ cursor: "pointer" }}
/>
</div>
</div>

<Divider />

<div className={styles.contentWrap}>
<h3>Compliant Status</h3>
<button
style={{
backgroundColor:
(docsDetails?.status === "Approved" && "#27AE60") ||
(docsDetails?.status === "Declined" && "#EB5757") ||
(docsDetails?.status === "Pending" && "#F2C94C") ||
"rgba(169, 170, 171, 0.22)",
color:
(docsDetails?.status === "Approved" && "#FFFFFF") ||
(docsDetails?.status === "Declined" && "#FFFFFF") ||
(docsDetails?.status === "Pending" && "#FFFFFF") ||
"#FFFFFF"
}}
>
{docsDetails?.status}
</button>
</div>
<div className={styles.contentoverflow}>
<div className={styles.contentImage}>
<img src={docsDetails?.image} alt="" />
</div>
<div className={styles.contentWord}>
<h3>Compliant Comment</h3>
<Divider style={{ margin: "0px", padding: "0px" }} />
<p className={styles.contentWord_p}>{docsDetails?.comment}</p>
</div>
</div>

<div className={styles.contentButton}>
<button
disabled={docsDetails?.id <= 1}
onClick={() => moveHandler("back")}
className={styles.contentButtonBack}
>
{back}
</button>
{/* <button
disabled={docsDetails?.id >= docs?.length}
onClick={() => moveHandler('next')}
className={styles.contentButtonNext}>
{next}
</button>
</div>
</div>
</Modal> */}
				</div>
			</div>
		</>
	);
}

export default Document;
